import { useParams } from "react-router-dom"
import BlogNavbar from "../components/BlogNavbar";
import BlogEntry from "../components/BlogEntry";

import api from "../../../api";
import { useEffect, useState } from "react";



const BlogType = () => {

  const { type: blogType } = useParams();

  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const getPostsFromType = async () => {
      const response = await api.get("/post/type/" + blogType);
      setPosts(response.data);
    }

    getPostsFromType();



  }, [blogType])


  return (
    <div>
      <BlogNavbar />

      <div className="blogHomeBody">
        <div className="row">
          {

            posts.map((post, index) => {
              return (
                <BlogEntry key={"post" + index} post_id={post.post_id} title={post.title} rating={post.post_rating} content={post.content} thumbnail={post.thumbnail} date={post.created_at} type={post.post_type}/>
              )
            })

          }
        </div>

      </div>

    </div>
  )
}

export default BlogType;